import React from 'react';
import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { useDispatch, useSelector } from 'react-redux';
import { getStatusFilter } from '../../redux/selectors/flyingPage';
import { FlightStatusFilterEnum } from '../../types/flyingPage';
import { setStatusFilter } from '../../redux/slice/flyingPage/flyingPage';

const FlightStatusFilter: React.FC = () => {
  const dispatch = useDispatch();
  const selectedItem = useSelector(getStatusFilter);

  function handleChange(event: RadioChangeEvent) {
    event.preventDefault();
    dispatch(setStatusFilter(event.target.value));
  }

  return (
    <div className="flight-detail-filter-common">
      <Radio.Group defaultValue={selectedItem} buttonStyle="solid" onChange={handleChange}>
        <Radio.Button value={FlightStatusFilterEnum.NOW}>Now</Radio.Button>
        <Radio.Button value={FlightStatusFilterEnum.TODAY}>Today</Radio.Button>
        <Radio.Button value={FlightStatusFilterEnum.LAST24H}>24 h</Radio.Button>
        <Radio.Button value={FlightStatusFilterEnum.LAST7D}>7 days</Radio.Button>
        <Radio.Button value={FlightStatusFilterEnum.ALL}>All</Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default FlightStatusFilter;
